import * as React from 'react';

// Inputs outside a disabling provider keep their own disabled-state rules.
export const InputDisabledContext = React.createContext(false);

export const useInputDisabled = () => React.useContext(InputDisabledContext);

export const InputDisabledProvider: React.FC<{ disabled: boolean }> = ({ disabled, children }) => {
    const parentDisabled = useInputDisabled();
    return <InputDisabledContext.Provider value={parentDisabled || disabled}>{children}</InputDisabledContext.Provider>;
};
